import React from "react";
import { UserRegistrationTemplate } from "../../Templates/userRegistrationTemplate";

export const UserRegistration = () => {
  return <UserRegistrationTemplate />;
};
